// Some injects
import './process-polyfill';
import './utils/dom-patch';
import './index.css';
import './tokens.css';
import './antd-overrides.css';
import './audio-controls.css';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@refly/ai-workspace-common/utils/request';
import { setupI18n } from '@refly/web-core';
import { App } from './App';
import { initServiceWorker } from './service-worker';

// 在挂载 React 树之前同步初始化 i18n，避免组件 useTranslation 时实例未就绪而直接显示翻译 key。
setupI18n();

// Initialize Service Worker (includes registration and message handling)
initServiceWorker();

// 与 rsbuild 的 VITE_BASE_PATH 保持一致：生产为 /AIMflyV1，开发为空。
const routerBasename = (process.env.VITE_BASE_PATH || '').replace(/\/+$/, '') || undefined;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={routerBasename}>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);
